import { Box, Image, Typography } from "@jewlr/storybook/core"
import React from "react"
import styled from "styled-components"

const BannerBlock = styled(Box).attrs((props) => ({
  ...props.theme.paymentPlans.klarna.bannerBlock,
}))``
const Banner = () => {
  return (
    <BannerBlock>
      <Box contain py={{ _: 6, tablet: 8 }} textAlign="center">
        <Image
          alt="Klarna"
          mb={1}
          src={require("images/info/klarna/jewlr4-klarna-logo.png")}
          width={{ _: "240px", tablet: "353px" }}
        />
        <Typography
          fontSize={{ _: "32px", tablet: "50px" }}
          fontWeight="700"
          letterSpacing="1px"
          lineHeight="1.2"
          px={{ _: 3, desktop: "180px", tablet: "90px" }}
        >
          A Payment Experience Shoppers Love
        </Typography>
      </Box>
    </BannerBlock>
  )
}

export default Banner
